import { useEffect } from 'react';
import { useHistory, useLocation, match } from 'react-router-dom';
import { DiscountCode } from '@qover-private/protos-web/qover/dojo/contracts/v1/contract';
import { Risk } from '@qover-private/protos-web/qover/dojo/bike/v1/risk';
import { StringTuple } from '@qover-private/protos-web/qover/dojo/common/v1/string_tuple';
import { Draft } from '../../domain/Draft';
import { Type } from '../../domain/Risk';

type BikeCreateDraftProps = {
  match: match;
  handleCreateOnMount: (draft: Draft) => Promise<Draft>;
};

const BikeCreateDraft = (props: BikeCreateDraftProps) => {
  const history = useHistory();
  const location = useLocation();
  const { handleCreateOnMount } = props;
  const search = new URLSearchParams(location.search);

  useEffect(() => {
    if (!search.get('id')) {
      let discountCodes: DiscountCode[] = [];
      const risk: Risk = {};
      const metadata: StringTuple[] = [];

      const discountCode = search.get('promocode');
      const bikeValue = search.get('bikevalue');
      const bikeType = search.get('biketype');
      const referralId = search.get('referralid');

      if (discountCode || bikeValue || bikeType || referralId) {
        if (discountCode) {
          discountCodes = [{ name: discountCode }];
        }

        if (bikeValue) {
          risk.originalValue = Number(bikeValue);
        }

        if (bikeType) {
          risk.type = bikeType as Type;
        }

        if (referralId) {
          const meta: StringTuple = {
            key: 'referralId',
            value: referralId,
          };
          metadata.push(meta);
        }

        const draft = new Draft({
          risk,
          discountCodes,
          metadata,
          policyholder: {},
          settings: {},
          coverages: {},
          terms: {},
          totalCoverage: {},
        });

        handleCreateOnMount(draft)
          .then(response => {
            search.set('id', response.draftId as string);
            search.delete('referralid');
          })
          .catch(err => {
            console.error(err);
          })
          .finally(() => {
            search.delete('promocode');
            search.delete('bikevalue');
            search.delete('biketype');
            history.replace(`${props.match.url}/quote?${search.toString()}`);
          });
      }
    }
  }, []);

  return null;
};

export default BikeCreateDraft;
